module.exports = __webpack_public_path__ + "2e4eeb13532cbf8f2ba6c2b1e586c27e.png";